import React, { useState } from "react";
import Button from "../../components/Button";
import VideoPlayer from "../../components/VideoPlayer";

export default function DiagnosticoDisfagiaOrofaringea() {

  const [videoAbierto, setVideoAbierto] = useState(null);

  const abrirVideo = (url) => {
    setVideoAbierto(url);
  };

  const cerrarVideo = () => {
    setVideoAbierto(null);
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h4 className="font-bold text-center">Usuario/a con diagnóstico de disfagia orofaríngea</h4>
      </div>

      {/* Introducción */}
      <div className="bg-white border rounded-lg p-4 leading-relaxed text-justify">
        <p className="mb-2">
          El MECV-V adaptado es un método clínico que consiste en administrar una serie de bolos de
          3 viscosidades (néctar, líquido y pudín) de 5 a 20 mL de volumen. Estos se suministran
          secuencialmente donde hay una progresión en cuanto a dificultad. En ocasiones, los pacientes
          no toleran 20 mL para la realización de la prueba y se disminuye ese volumen a 15 mL.
        </p>
        <p className="mb-2">
          Debe ser realizado por personal sanitario experimentado / entrenado que sepa interpretarlo.
        </p>
        <p className="font-semibold mb-2">
          Es imprescindible la preparación y colaboración por parte del paciente y, para ello, es necesario:
        </p>
        <ul className="list-disc pl-6 space-y-1">
          <li>Explicar al paciente en qué consiste la prueba.</li>
          <li>Se precisa un mínimo estado de alerta que permita colaborar en la prueba.</li>
          <li>Posición adecuada: incorporado, sentado.</li>
          <li>Colocar pulsioxímetro.</li>
          <li>Se le pide que diga su nombre para valorar timbre de voz.</li>
        </ul>
      </div>

      {/* Cuadro de material necesario */}
      <div className="bg-white border rounded-lg p-4 flex flex-col gap-3">
        <h5 className="font-bold mb-1 text-center">MATERIAL NECESARIO</h5>
        <iframe
          src="/docs/mecv-v.pdf"
          title="MECV-V"
          className="w-full h-[420px] border rounded-lg"
        ></iframe>

        <p className="text-center font-semibold text-gray-600">
          RECUERDA: es necesario tener un aspirador para secreciones por seguridad.
        </p>
      </div>

      {/* PDF descargable debajo del cuadro */}
      <div className="bg-white border rounded-lg p-4">
        <h5 className="font-bold mb-3 text-center">DOCUMENTO MECV-V DESCARGABLE</h5>
        <iframe
          src="/docs/mecv-v_descargable.pdf"
          title="MECV-V Descargable"
          className="w-full h-[500px] border rounded-lg"
        ></iframe>
        <p className="mt-3 text-center text-gray-600">
          Puedes imprimir o guardar este documento para registrar manualmente los resultados de la prueba MECV-V.
        </p>
      </div>

      {/* Videos */}

      <div className="flex flex-col gap-4 mt-2">

        {/* Cuadro 1 */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="mb-6 text-center font-semibold">MÉTODO DE EXPLORACIÓN CLÍNICA VOLUMEN VISCOSIDAD (MECV-V)</p>
          <div className="flex justify-center">
            <Button onClick={() => abrirVideo("/videos/metodo-de-exploracion-clinica-volumen-viscosidad_mecv-v.mp4")}>
              Ver vídeo
            </Button>
          </div>
        </div>

        {/* Cuadro 2 */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="mb-6 text-center font-semibold">INICIO DEL TEST DE DEGLUCIÓN: VISCOSIDAD LÍQUIDA (AGUA)</p>
          <div className="flex justify-center">
            <Button onClick={() => abrirVideo("/videos/inicio-del-test-de-deglucion_viscosidad-liquida-agua.mp4")}>
              Ver vídeo
            </Button>
          </div>
        </div>

        {/* Cuadro 3 */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="mb-6 text-center font-semibold">INICIO DEL TEST DE DEGLUCIÓN: VISCOSIDAD NÉCTAR</p>
          <div className="flex justify-center">
            <Button onClick={() => abrirVideo("/videos/inicio-del-test-de-deglucion_viscosidad-nectar.mp4")}>
              Ver vídeo
            </Button>
          </div>
        </div>

        {/* Cuadro 4 */}
        <div className="bg-[#dfeaf7] p-6 rounded-lg shadow">
          <p className="mb-6 text-center font-semibold">INICIO DEL TEST DE DEGLUCIÓN: VISCOSIDAD PUDÍN</p>
          <div className="flex justify-center">
            <Button onClick={() => abrirVideo("/videos/inicio-del-test-de-deglucion_viscosidad-pudin.mp4")}>
              Ver vídeo
            </Button>
          </div>
        </div>
      </div>

      {/* Modal VideoPlayer */}
      {videoAbierto && (
        <VideoPlayer videoUrl={videoAbierto} onClose={cerrarVideo} />
      )}
    </div>
  );
}